import React from 'react';
import Link from '../Link';

// Style
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, useIntl } from 'react-intl';
import bt from '../../components/commonStyle.css';
import s from './Dashboard.css';

// Locale
import messages from '../../locale/messages';

// Images
import ChatIMage from '/public/SiteIcons/chat.svg';
import ArrowIcon from '/public/SiteIcons/chevron-right.svg';
import StarImage from '/public/SiteIcons/star.svg';
import UserGreen from '/public/SiteIcons/userGreen.svg';

const DashboardMenu = () => {
  const intl = useIntl();

  return (
    <div className={cx(s.quickLinksRow)}>
      {/* Mis reservas */}
      <Link to={'/inbox'} className={cx(s.quickLinkCard, s.noTextDecoration)}>
        <div className={s.quickLinkIconWrap}>
          <img src={ChatIMage} alt="Todos los mensajes" className={s.quickLinkIcon} />
        </div>
        <div className={s.quickLinkInfo}>
          <span className={s.quickLinkTitle}><FormattedMessage {...messages.allMessages} /></span>
          <span className={s.quickLinkDesc}>Habla con tus anfitriones ó huespedes.</span>

        </div>
        <img src={ArrowIcon} alt="" className={s.quickLinkArrow} />
      </Link>

      {/* Favoritos */}
      <Link to={'/user/reviews/about-you'} className={cx(s.quickLinkCard, s.noTextDecoration)}>
        <div className={cx(s.quickLinkIconWrap, s.quickLinkIconBlue)}>
          <img src={StarImage} alt="Reseñas" className={s.quickLinkIcon} />
        </div>
        <div className={s.quickLinkInfo}>
          <span className={s.quickLinkTitle}> <FormattedMessage {...messages.reviews} /></span>
          <span className={s.quickLinkDesc}>Revisa lo que tus huespedes escribieron sobre ti.</span>
        </div>
        <img src={ArrowIcon} alt="" className={s.quickLinkArrow} />
      </Link>

      {/* Mensajes */}
      <Link to={'/user/edit'} className={cx(s.quickLinkCard, s.quickLinkCardGreen, s.noTextDecoration)}>
        <div className={cx(s.quickLinkIconWrap, s.quickLinkIconGreen)}>
          <img src={UserGreen} alt="Mensajes" className={s.quickLinkIcon} />
        </div>
        <div className={s.quickLinkInfo}>
          <span className={s.quickLinkTitle}><FormattedMessage {...messages.updateProfile} /></span>
          <span className={s.quickLinkDesc}>Revisa y actualiza tu IconPerfil.</span>
        </div>
        <img src={ArrowIcon} alt="" className={cx(s.quickLinkArrow, s.quickLinkArrowGreen)} />
      </Link>
    </div>
  );
};

export default withStyles(s, bt)(DashboardMenu);